module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight Factory Execution")])], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.ALLMODULE ? _vm.ALLMODULE : '',
      "jobSeriesBanner": _vm.JOBSERIES ? _vm.JOBSERIES : '',
      "bannerClientName": _vm.mainEntryData.length > 0 ? _vm.mainEntryData[0].clientName : '',
      "trackingId": _vm.trackingId != '' ? _vm.trackingId : '',
      "iconId": "fa fa-ship"
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "mt-2"
  }), _vm._v(" "), (
    _vm.ffExportDetail.stuffingType == 'factoryStuffing' &&
    _vm.ffExportDetail.containerInfo == 'fcl'
  ) ? _c('div', [_c('div', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload Documents")]), _vm._v(" "), (_vm.ALLMODULE) ? _c('container-component', {
    attrs: {
      "allModuleIdContainer": _vm.ALLMODULE,
      "JOB": "FF"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.proceedNext == '1') ? _c('div', [_c('div', [_c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Factory Stuffing at\n                        " + _vm._s(_vm.ffExportDetail.portType == "Icd" ? "ICD" : "PORT"))])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('b', [_vm._v("Transportation By :")])]), _vm._v(" "), (!_vm.factoryStuffing.transportationBy) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorExecution.transportationBy))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "id": "isKYC1",
      "name": "isKYC1",
      "md-value": "Pridel"
    },
    model: {
      value: (_vm.factoryStuffing.transportationBy),
      callback: function($$v) {
        _vm.$set(_vm.factoryStuffing, "transportationBy", $$v)
      },
      expression: "factoryStuffing.transportationBy"
    }
  }, [_vm._v("Pridel")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "id": "isKYC2",
      "name": "isKYC2",
      "md-value": "Shipper"
    },
    model: {
      value: (_vm.factoryStuffing.transportationBy),
      callback: function($$v) {
        _vm.$set(_vm.factoryStuffing, "transportationBy", $$v)
      },
      expression: "factoryStuffing.transportationBy"
    }
  }, [_vm._v("Shipper")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("VGM Submission Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "vgmSubmissionDate",
      "id": "vgmSubmissionDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.factoryStuffing.vgmSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.factoryStuffing, "vgmSubmissionDate", $$v)
      },
      expression: "factoryStuffing.vgmSubmissionDate"
    }
  }), _vm._v(" "), (_vm.factoryStuffing.vgmSubmissionDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.factoryStuffing.vgmSubmissionDate_err))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("SI Submission Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "siSubmissionDate",
      "id": "siSubmissionDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.factoryStuffing.siSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.factoryStuffing, "siSubmissionDate", $$v)
      },
      expression: "factoryStuffing.siSubmissionDate"
    }
  }), _vm._v(" "), (_vm.factoryStuffing.siSubmissionDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.factoryStuffing.siSubmissionDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("TR Submission Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "trSubmissionDate",
      "id": "trSubmissionDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.factoryStuffing.trSubmissionDate),
      callback: function($$v) {
        _vm.$set(_vm.factoryStuffing, "trSubmissionDate", $$v)
      },
      expression: "factoryStuffing.trSubmissionDate"
    }
  }), _vm._v(" "), (_vm.factoryStuffing.trSubmissionDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.factoryStuffing.trSubmissionDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Handover Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "handoverDate",
      "id": "handoverDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.factoryStuffing.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.factoryStuffing, "handoverDate", $$v)
      },
      expression: "factoryStuffing.handoverDate"
    }
  }), _vm._v(" "), (_vm.factoryStuffing.handoverDate_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.factoryStuffing.handoverDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "vgmBy"
    }
  }, [_vm._v("VGM By")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1,
      "list": _vm.vgmByList,
      "option-value": "vgmByValue",
      "option-text": "vgmByText",
      "placeholder": "Select",
      "name": "vgmBy",
      "id": "vgmBy"
    },
    on: {
      "input": _vm.addVgmByShipper
    },
    model: {
      value: (_vm.factoryStuffing.vgmBy),
      callback: function($$v) {
        _vm.$set(_vm.factoryStuffing, "vgmBy", $$v)
      },
      expression: "factoryStuffing.vgmBy"
    }
  })], 1), _vm._v(" "), (_vm.factoryStuffing.vgmBy == 'SHIPPER') ? _c('b-button', {
    staticStyle: {
      "margin-top": "35px !important"
    },
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload Shipper VGM")]) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('b-row', [(_vm.ALLMODULE) ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('UpdateContainerWithSOB', {
    attrs: {
      "allModuleId": Number(_vm.ALLMODULE),
      "JobNo": _vm.JOBSERIES
    },
    on: {
      "update": _vm.getData
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.proceedNext == '1') ? _c('div', {
    staticClass: "mt-3"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.AppovalMSG))]), _c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('PAYTEST')
      }
    }
  }, [_vm._v("Save & Proceed To S-Line Payment")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVGM"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.ALLMODULE && _vm.is_approval_mail_action > 0) ? _c('ResetSlineSubscription', {
    attrs: {
      "allModuleId": Number(_vm.ALLMODULE),
      "JobNo": _vm.JOBSERIES
    },
    on: {
      "refresh-data": _vm.getData
    }
  }) : _vm._e(), (_vm.ALLMODULE && _vm.is_approval_mail_action > 0) ? _c('br') : _vm._e(), _vm._v(" "), (!_vm.ffExportDetail.mergeffExportId || _vm.ffExportDetail.mergeffExportId == '0') ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "id": "addButtonLoaderBL",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('BLRaised')
      }
    }
  }, [_vm._v("Save & Proceed to Raise B/L")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderBL"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderHand"
    },
    on: {
      "click": function($event) {
        _vm.addFactoryExecution('handover')
      }
    }
  }, [_vm._v(_vm._s(_vm.ffExportDetail.portType == "Icd" ?
    "Save & Proceed to Handover to Rail" :
    "Save & Proceed to Gate ­ in at Terminal By Road"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderHand"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e()], 1) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop7",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose7
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39930efe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/newffExecution.vue
// module id = 2527
// module chunks = 0